import { ILogger } from '@cian/logger';

import { IChat } from '../../types/chatList';
import { validateChatItem } from '../../utils/validateChatItem';

export const getLastTimeStamp = (chats: IChat[]): number => chats[chats.length - 1].updated;

export const mergeChats = (stateChats: IChat[], actionChats: IChat[], logger?: ILogger): IChat[] => {
  const validatedActionChats = actionChats.filter(chat => validateChatItem({ chat, logger }));

  return stateChats
    .map(stateChat => {
      const chatIndex = validatedActionChats.findIndex(actionChat => actionChat.chatId === stateChat.chatId);

      if (chatIndex < 0) {
        return stateChat;
      }

      const actionChat = validatedActionChats[chatIndex];
      validatedActionChats.splice(chatIndex, 1);

      return actionChat.updated >= stateChat.updated ? actionChat : stateChat;
    })
    .concat(validatedActionChats)
    .sort((a, b) => b.updated - a.updated);
};
